import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BuildingSurveyViewModel } from "src/app/shared/Models/buildingTableViewModel";
import { APIEndpoints } from "../../../../config/apiEndpoint.config";
import { HttpService } from "../../../shared/http.service";
import { BuildingGroup } from "../../../shared/Models/read/BuildingGroup";
import { AddBuildingRangeToBuildingGroupDto } from "../../../shared/Models/write/AddBuildingRangeToBuildingGroupDto";
import { AddBuildingRangeToNewBuildingGroupDto } from "../../../shared/Models/write/AddBuildingRangeToNewBuildingGroupDto";
import { RemoveGroupFromBuildingsDto } from "../../../shared/Models/write/RemoveGroupFromBuildingsDto";

@Injectable({
  providedIn: "root",
})
export class BuildingGroupService {
  constructor(private httpService: HttpService) {}

  getBuildingGroupsByAreaId(areaId: string): Observable<BuildingGroup[]> {
    return this.httpService.get(
      APIEndpoints.findAllBuildingGroupsByAreaId + areaId
    );
  }

  getBuildingsByBuildingGroupId(
    buildinggroupId: string
  ): Observable<BuildingSurveyViewModel[]> {
    return this.httpService
      .get(APIEndpoints.getBuildingsByBuildingGroupId + buildinggroupId)
      .pipe(
        map((res: any) => {
          return res.map((r) => new BuildingSurveyViewModel().deserialize(r));
        })
      );
  }

  getTempBuildingGroupName(
    data: AddBuildingRangeToNewBuildingGroupDto
  ): Observable<{ groupName }> {
    return this.httpService.getWithParams<{ groupName }>(
      APIEndpoints.getTempBuildingGroupName,
      {
        areaId: data.areaId,
        buildingIds: data.buildingIds,
      }
    );
  }

  addBuildingsToExistingGroup(data: AddBuildingRangeToBuildingGroupDto) {
    return this.httpService.post(
      APIEndpoints.addBuildingRangeToBuildingGroup,
      data,
      true
    );
  }

  addBuildingsToNewGroup(data: AddBuildingRangeToNewBuildingGroupDto) {
    return this.httpService.post(
      APIEndpoints.addBuildingRangeToNewBuildingGroup,
      data,
      true
    );
  }

  removeGroupFromBuildings(data: RemoveGroupFromBuildingsDto) {
    return this.httpService.post(
      APIEndpoints.removeGroupFromBuilding,
      data,
      true
    );
  }
}
